import React from 'react';
import { connect } from 'react-redux';
import {
  pullCampaignWebhooks,
  pullCanvassAlertConfigs,
  updateOrCreateCanvassAlertConfig,
  removeCanvassAlertConfig,
} from '../../store/api/calls';
import api from '../../store/api/api';
import { startCase, get } from 'lodash';

import AlertConfigCreateEditModal from '../theme/modals/AlertConfigCreateModal';
import AlertConfigWebhookModal from '../theme/modals/AlertConfigWebhookModal';
import { Link } from 'react-router-dom';
import DataTable from '../theme/tables/DataTable';
import Moment from 'moment';
import BaseModal from '../theme/modals/BaseModal';
import NavBaseTemplate from '../templates/NavBaseTemplate';

class AlertConfigEditor extends React.Component {
  static defaultProps = {
    onLoading: () => {},
    onError: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      editingInstance: null,
      createEditModalOpen: false,
      deleteModalOpen: false,
      webhookModalOpen: false,
      script: {},
    };
  }

  componentDidMount() {
    let sitecanvass_id = get(this.props, 'siteCanvass.id', null);
    let doorcanvass_id = get(this.props, 'doorCanvass.id', null);

    let script_id = get(
      this.props,
      'siteCanvass.script',
      get(this.props, 'doorCanvass.script', null)
    );

    Promise.allSettled([
      pullCampaignWebhooks(),
      pullCanvassAlertConfigs(sitecanvass_id, doorcanvass_id),
      api.get(`/scripts/${script_id}/`).then((res) => {
        this.setState({ script: res.data });
      }),
    ]);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.loading && prevProps.loading !== this.props.loading) this.props.onLoading();
    if (this.props.error && prevProps.error !== this.props.error) this.props.onError();
  }

  _filterKeysForDataTable = () => {
    return this.props.alertConfigs.map((d) => {
      let config = d.config;
      let webhooks = (d.webhooks || []).map((d) => {
        let match = this.props.webhooks.find((hook) => hook.id === d.webhook);
        if (match) {
          return match;
        } else {
          console.warn('Unable to find matching webhook', d);
          return {};
        }
      });
      let event_types = get(config, 'event_types', []);

      let script_element = config.script_element
        ? get(this.state, 'script.elements', []).find((d) => d.id === config.script_element)
        : null;

      let script_element_descriptor = script_element
        ? ` -- ${script_element.name} [${script_element.type}]`
        : '';

      return {
        trigger: startCase(config.trigger) + script_element_descriptor,
        operator: config.operator,
        value_threshold: config.value_threshold,
        time_threshold: config.time_threshold,
        for_event_types: event_types.reduce(
          (r, d, i) => `${r}${i !== 0 ? ',' : ''} ${startCase(d)}`,
          ''
        ),
        _for_event_types: event_types.length,
        webhooks: webhooks.reduce((r, d, i) => `${r}${i !== 0 ? ',' : ''} ${d.name}`, ''),
        _webhooks: webhooks.length,
        created_on: new Moment(d.created_at).format('MM/DD/YY'),
        _created_on: new Moment(d.created_at),
        _data: { ...config, ...d },
      };
    });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: null });
  };

  handleRemoveSubmission = () => {
    return removeCanvassAlertConfig(this.state.editingInstance).then(this.onCloseDeleteModal);
  };

  onCloseCreateEditModal = (createdInstance) => {
    // we created something
    if (!this.state.editingInstance && createdInstance) {
      this.setState({
        createEditModalOpen: false,
        editingInstance: { ...createdInstance, ...createdInstance.config },
        webhookModalOpen: true,
      });
    } else {
      // we edited a thing or just cancelled entirely without operation
      this.setState({
        createEditModalOpen: false,
        editingInstance: null,
      });
    }
  };

  render() {
    return (
      <div className={'screen-component-wrapper'}>
        <div className="button-table-top-wrapper">
          <button
            className="button primary-milligram"
            onClick={() => this.setState({ createEditModalOpen: true })}
          >
            + Add Alert Configuration
          </button>
          {!!this.props.buttons && !!this.props.buttons.length && [...this.props.buttons]}
        </div>
        <DataTable
          data={this._filterKeysForDataTable() || []}
          title={`Alert Configuration: ${
            this.props.siteCanvass.name || this.props.doorCanvass.name
          }`}
          actions={[
            {
              title: 'edit',
              icon: 'fa-edit',
              action: (modelInstance) =>
                this.setState({ editingInstance: modelInstance, createEditModalOpen: true }),
            },
            {
              title: 'webhooks',
              icon: 'fa-server',
              action: (modelInstance) =>
                this.setState({ editingInstance: modelInstance, webhookModalOpen: true }),
            },
            {
              title: 'delete',
              icon: 'fa-minus-square',
              action: (modelInstance) =>
                this.setState({ editingInstance: modelInstance, deleteModalOpen: true }),
            },
          ]}
        />

        {this.state.createEditModalOpen && (
          <AlertConfigCreateEditModal
            open={true}
            onClose={() => this.onCloseCreateEditModal(null)}
            siteCanvass={this.props.siteCanvass || {}}
            doorCanvass={this.props.doorCanvass || {}}
            script={this.state.script}
            editingInstance={this.state.editingInstance}
            onCompleteSubmission={(alertInstance) => this.onCloseCreateEditModal(alertInstance)}
          />
        )}

        {this.state.webhookModalOpen && (
          <AlertConfigWebhookModal
            open={true}
            onClose={() => this.setState({ webhookModalOpen: false, editingInstance: null })}
            editingInstance={this.state.editingInstance}
            onCompleteSubmission={() =>
              this.setState({ webhookModalOpen: false, editingInstance: null })
            }
          />
        )}

        {/*Delete Modal*/}

        {this.state.deleteModalOpen && !!this.state.editingInstance && (
          <BaseModal open={true} onClose={this.onCloseDeleteModal} center>
            <div className="modal-internal-wrapper">
              <p>
                Are you should we should delete{' '}
                <b>
                  {this.state.editingInstance.trigger} {this.state.editingInstance.operator}{' '}
                  {this.state.editingInstance.value_threshold}
                </b>
                ?
              </p>
              <div className="button-wrapper">
                <div className="button" onClick={this.handleRemoveSubmission}>
                  Remove
                </div>
                <div className="button button-outline" onClick={this.onCloseDeleteModal}>
                  Cancel
                </div>
              </div>
            </div>
          </BaseModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  alertConfigs: state.alertConfigs.data,
  webhooks: state.alertConfigs.webhooks,
  loading: state.alertConfigs.loading,
  error: state.alertConfigs.error,
});

export default connect(mapStateToProps)(AlertConfigEditor);
